<template>
  <div>
    <section-collapseable
      :title="contactName"
      editable
      @edit="editDetails"
    >
      <div v-if="contact.phone_1 || contact.phone_2" class="details_section">
        <h4 class="details_section--header text-uppercase">Phone</h4>

        <phone-number-display
          :number="contact.phone_1"
          :dnc="contact.is_phone_one_on_do_not_contact_list"
          is-primary
        />

        <phone-number-display
          :number="contact.phone_2"
          :dnc="contact.is_phone_two_on_do_not_contact_list"
        />

        <phone-number-display
          :number="contact.phone_3"
          :dnc="contact.is_phone_three_on_do_not_contact_list"
        />

        <phone-number-display
          :number="contact.phone_4"
          :dnc="contact.is_phone_four_on_do_not_contact_list"
        />

        <phone-number-display
          :number="contact.phone_5"
          :dnc="contact.is_phone_five_on_do_not_contact_list"
        />

        <phone-number-display
          :number="contact.phone_6"
          :dnc="contact.is_phone_six_on_do_not_contact_list"
        />

        <phone-number-display
          :number="contact.phone_7"
          :dnc="contact.is_phone_seven_on_do_not_contact_list"
        />

        <phone-number-display
          :number="contact.phone_8"
          :dnc="contact.is_phone_eight_on_do_not_contact_list"
        />

        <phone-number-display
          :number="contact.phone_9"
          :dnc="contact.is_phone_nine_on_do_not_contact_list"
        />

        <phone-number-display
          :number="contact.phone_10"
          :dnc="contact.is_phone_ten_on_do_not_contact_list"
        />
      </div>

      <div v-if="contact.email_address" class="details_section">
        <h4 class="details_section--header text-uppercase">Email</h4>

        <p>
          <sensitive-data-wrapper>
            <template v-if="!contact.is_mailable">
              <del>{{ contact.email_address }}</del>
              <small>DNC</small>
            </template>
            <template v-else>{{ contact.email_address }}</template>
          </sensitive-data-wrapper>
        </p>
      </div>

      <div v-if="contact.street || contact.city || contact.state || contact.postcode" class="details_section">
          <h4 class="details_section--header text-uppercase">Address</h4>

        <sensitive-data-wrapper>
          <p v-if="contact.street">{{ contact.street }}</p>
          <p v-if="contact.line_2">{{ contact.line_2 }}</p>
          <p>
            <template v-if="contact.city">{{ contact.city }},</template>
            <template v-if="contact.state">{{ contact.state }}</template>
            <template v-if="contact.postcode">{{ contact.postcode }}</template>
          </p>
        </sensitive-data-wrapper>
      </div>

      <div v-if="contact.timezone" class="details_section">
        <h4 class="details_section--header text-uppercase">Timezone</h4>
        <p>{{ contact.timezone }}</p>
      </div>
    </section-collapseable>

    <section-collapseable hide-initial-when-expanded>
      <comm-buttons
        :contact="contact"
        :available-records="records"
        include-button-text
      ></comm-buttons>
    </section-collapseable>

    <modal-container>
      <modal-crud-form
        ref="contactDetailsModal"
        title="Contact"
        form-component="contact-form"
        hide-delete-button
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import CommButtons from "../../../components/comms/CommButtons";
import PhoneNumberDisplay from "../components/PhoneNumberDisplay";
import SensitiveDataWrapper from "../../../components/SensitiveDataWrapper.vue";

export default {
  name: "ContactDetails",
  components: {
    SensitiveDataWrapper,
    PhoneNumberDisplay,
    CommButtons,
  },
  computed: {
    contact() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.contact : {
        full_name: ' ',
        phone_1: null,
        phone_2: null,
        email_address: null,
        is_mailable: false,
        street: null,
        city: null,
        state: null,
        postcode: null,
        timezone: null,
      };
    },
    contactName() {
      return this.$utils.displayFullName(this.contact.full_name);
    },
    records() {
      if(!this.$store.state.activeContact) return [];

      let recordClone = this.$utils.clone(this.$store.state.activeContact.records);
      return recordClone.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    },
  },
  methods: {
    editDetails() {
      this.$refs.contactDetailsModal.open(this.contact);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.details_section {
  margin-top: 16px;

  &:first-of-type {
    margin-top: 8px;
  }

  &--header {
    margin-bottom: 4px;
    font-size: 0.625rem;
  }

  p {
    margin-bottom: 4px;
  }
}
</style>
